<template>
	<div class="plans-hero-section hero-section">
		<div class="mx-auto max-w-2xl px-6 pb-72 pt-24 text-center sm:pt-32 lg:px-8">
			<div class="mx-auto">
				<h1
					class="gradient-title-white text-white text-[60px] lg:text-[64px] font-medium mb-[16px] lg:mb-[32px] text-center w-full max-w-[848px] text-center mx-auto"
				>
					Simple, Transparent Pricing
				</h1>
			</div>
			<div class="relative mt-6">
				<p class="text-center text-slate-100 mb-[32px] text-xl">
					Whether you're a beginner or advanced trader, StocksToTrade is about to
					become your #1 trading companion going forward.
				</p>
			</div>
		</div>
		<div class="flow-root bg-black pb-24 sm:pb-32">
			<div class="-mt-80">
				<div class="mx-auto max-w-7xl px-6 lg:px-8">
					<div
						class="mx-auto grid max-w-md grid-cols-1 gap-8 lg:max-w-4xl lg:grid-cols-2"
					>
						<PlansCard
							title="Monthly"
							price="$179.95"
							ctaAppearence="basic-white"
							textPrice="Unlimited Access"
							dataCtaType="monthly-pricing-trial"
							:button="{
								title: '14-Day Trial — Only $7',
								link: 'https://cfn.stockstotrade.com/try-stt2'
							}"
							text='Get StocksToTrade software and
                            <a class="text-blue-300"
                                href="https://stockstotrade.com/stt-university-opens-doors-future-pro-traders/">
                                StocksToTrade University
                            </a>
                            where we have a library of training videos, best practices and support.'
						></PlansCard>
						<PlansCard
							dealText="BEST VALUE"
							title="Annual"
							price="$1899.50"
							textPrice="Save $250 Instantly"
							textPriceStyle="badge"
							ctaAppearence="primary"
							dataCtaType="yearly-pricing-trial"
							:border="true"
							:button="{
								title: 'Get Started Now',
								link: 'https://cfn.stockstotrade.com/platform-access'
							}"
							text="All the features of the Monthly plan plus get $250 OFF immediately with your one-time payment today. You’ll never see an interruption in service."
						></PlansCard>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup></script>

<style lang="scss" scoped>
.plans-hero-section {
	background: linear-gradient(110deg, #091d56 8.05%, #331290 77.58%);
	position: relative;
	overflow: hidden;
	&::before {
		content: "";
		height: 100%;
		width: 100%;
		background:
			url("/images/hero-section-bg.avif"),
			lightgray 50%;
		position: absolute;
		left: 0;
		top: -124px;
		mix-blend-mode: overlay;
		opacity: 0.6;
		background-size: cover;
		background-repeat: no-repeat;
		transform: scale(1.5) translateX(16vw);
		z-index: 0;
		pointer-events: none;
	}
	.flow-root {
		position: relative;
		z-index: 1;

		> div {
			transform: translateY(80px);
		}
	}
}
</style>
